import { Card, CardBody, Col } from "reactstrap";
import { H1, Image, P } from "../../../../AbstractElements";
import { dynamicImage, dynamicNumber } from "../../../../Utils";
import { Link } from "react-router-dom";

const WelcomeBackCard = () => {
  return (
    <Col xxl="3" lg="4" md="5" sm="6" className="box-col-4">
      <Card className="profile-greeting">
        <CardBody>
          <div>
            <Image className="greeting-img" src={dynamicImage("dashboard/welcome.png")} alt="welcome" />
            <H1>Welcome back!</H1>
            <P>Get to work on the project you were given.</P>
            <Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}/applications/project/project-list`}>
              Now Let's Get Started
            </Link>
          </div>
          {dynamicNumber(5).map((item) => (
            <Image className={`vector-${item}`} key={item} src={dynamicImage(`dashboard/vector/${item}.png`)} alt="vector" />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default WelcomeBackCard;
